import { compose, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { addProps } from 'utils/recompose';
import { renderNothingIfPropFalsy } from 'utils/recompose';

export const text = {
  overWarning: 'Over quota by',
  underWarning: 'Under quota by',
};

const propTypes = {
  calculatedRemainingQuota: PropTypes.number.isRequired,
  currentSelectedQuantity: PropTypes.number.isRequired,
  inCartQuantity: PropTypes.number.isRequired,
  modelTemplatesWorkingStateLoading: PropTypes.bool.isRequired,
  seriesAllocationLoading: PropTypes.bool.isRequired,
};

export const loaded = ({
  modelTemplatesWorkingStateLoading,
  seriesAllocationLoading,
}) => !Boolean(modelTemplatesWorkingStateLoading || seriesAllocationLoading);

export const calculatedTemplatesQuantity = ({
  currentSelectedQuantity,
  inCartQuantity,
}) => currentSelectedQuantity - inCartQuantity;

export const quotaWarning = ({
  calculatedRemainingQuota,
  calculatedTemplatesQuantity,
}) => {
  if (
    calculatedRemainingQuota &&
    calculatedRemainingQuota < calculatedTemplatesQuantity
  ) {
    const overQuantity = calculatedTemplatesQuantity - calculatedRemainingQuota;
    return `${text.overWarning} ${overQuantity}`;
  } else if (
    calculatedRemainingQuota &&
    calculatedRemainingQuota > calculatedTemplatesQuantity
  ) {
    const underQuantity =
      calculatedRemainingQuota - calculatedTemplatesQuantity;
    return `${text.underWarning} ${underQuantity}`;
  } else {
    return null;
  }
};

export default compose(
  setPropTypes(propTypes),
  addProps({ loaded }),
  renderNothingIfPropFalsy('loaded'),
  addProps({ calculatedTemplatesQuantity }),
  addProps({ quotaWarning }),
  renderNothingIfPropFalsy('quotaWarning'),
);
